
export  function getToken() {
  return localStorage.getItem('xf1_web_token')
}
export function setToken(token) {
  return localStorage.setItem('xf1_web_token',token)
}
